import IconShopOutline from '@adv-mt/mt-svg-icons/lib/ShopOutline.js'
import IconUsersOutline from '@adv-mt/mt-svg-icons/lib/UsersOutline.js'

const SELLER_TYPES = {
  PRIVATE: 2,
  PROFESSIONAL: 1
}

export const ICONS_BY_SELLER_TYPE = {
  [SELLER_TYPES.PRIVATE]: IconUsersOutline,
  [SELLER_TYPES.PROFESSIONAL]: IconShopOutline
}
